import Main from "./pages/main/main";
import Documents from "./pages/documents/documents";
import Calendar from "./pages/calendar/calendar";
import Contacts from "./pages/contacts/contacts";
import Sportsmens from "./pages/sportsmens/sportsmens";
import Polog from "./pages/polog/polog";
import Protocol from "./pages/protocol/protocol";
import Norm from "./pages/norm/norm";
import Record from "./pages/record/record";
import Anti from "./pages/anti/anti";
import Albom from "./pages/albom/albom";
import Zayavka from "./pages/zayavka/zayavka";
import Lk from "./pages/lk/lk";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import api from "./api";
import Login from "./pages/login/login";
import Register from "./pages/register/register";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setAuthorized, setUnauthorized } from "./store/userSelector";
import "./App.css";
import { ADMIN } from "./env";
import { ThemeProvider } from "@mui/material/styles";
import light_theme from "./theme/lightTheme";
import dark_theme from "./theme/darkTheme";
import CssBaseline from "@mui/material/CssBaseline";
import { styled, alpha } from "@mui/material/styles";

function App() {
  const MainDiv = styled("div")(({ theme }) => ({
    // backgroundImage: `url(${cover})`,
    // backgroundRepeat: "no-repeat",
    // backgroundSize: "cover",
    backgroundColor: alpha(theme.color.body, 0.5),

    minHeight: "50vh",
    // ...theme.typography.body2,
    // padding: theme.spacing(1),
    // textAlign: "center",
    // color: theme.palette.text.secondary,
    // marginTop: "0px",
  }));
  const Theme = useSelector((state) => state.themeSelector.theme);
  // const Theme = localStorage.getItem("theme");

  const isAuthorized = useSelector((state) => state.userSelector.authorized);
  const [load, setLoad] = useState(false);
  const dispatch = useDispatch();
  const ExternalRedirect = () => {
    useEffect(() => {
      window.location.href = ADMIN;
    }, []);

    return null; // компонент ничего не рендерит
  };
  const authCheckFunc = (token) => {
    api
      .authCheck(token)
      .then((response) => {})
      .catch((error) => {
        if (error.message === "Ошибка сети") {
          window.location.reload();
        } else if (error.response && error.response.status === 403) {
          console.log("выходим из личного кабинета, ошибка");
          dispatch(setUnauthorized());
        }
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("token_fprz");
    // console.log("Откуда взялся токен?");
    // console.log(token);
    if (token) {
      dispatch(setAuthorized(token));
    }
    authCheckFunc(token);

    setLoad(true);
  }, [dispatch]);

  return (
    <ThemeProvider theme={Theme ? light_theme : dark_theme}>
      <CssBaseline />
      <MainDiv>
        <BrowserRouter>
          <Routes>
            {load ? (
              isAuthorized ? (
                <Route path="/lk" element={<Lk />} />
              ) : (
                <>
                  <Route path="*" element={<Login />} />
                </>
              )
            ) : (
              <></>
            )}
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/sportsmens" element={<Sportsmens />} />
            <Route path="/registeruser" element={<Register />} />
            <Route path="/" element={<Main />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/protocol" element={<Protocol />} />
            <Route path="/polog" element={<Polog />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/norm" element={<Norm />} />
            <Route path="/record" element={<Record />} />
            <Route path="/albom" element={<Albom />} />
            <Route path="/anti" element={<Anti />} />
            <Route path="/zayavka" element={<Zayavka />} />
            <Route path="/admin" element={<ExternalRedirect />} />
            <Route path="*" element={<>404</>} />
          </Routes>
        </BrowserRouter>
      </MainDiv>
    </ThemeProvider>
  );
}

export default App;
